import { TradeTicket } from "@goodfill/models-typescript";
import { APIClass, graphqlOperation } from "aws-amplify";
import { convertApiToPortfolioPositionTradeTicket, PortfolioPositionTradeTicket } from "./PortfolioTradeTicket";
import { PortfolioCustomListPositionsQuery } from "./PortfolioCustomListPositionsQuery";
import { AccountId } from "@goodfill/domain-properties";

export type PortfolioPositionTradeTicketListItem = TradeTicket;

export interface PortfolioCustomTradeTicketListData {
  listTradeTickets: {
    items: PortfolioPositionTradeTicketListItem[];
  };
}

export async function doPortfolioCustomListPositions(
  graphqlApi: Pick<APIClass, "graphql">,
  accountId: AccountId,
): Promise<PortfolioPositionTradeTicket[]> {
  const operation = graphqlOperation(PortfolioCustomListPositionsQuery, {
    accountId: `${accountId}`,
  });
  const result = (await graphqlApi.graphql(operation)) as {
    data?: PortfolioCustomTradeTicketListData;
  };

  if (result.data === undefined) {
    throw new Error("result.data in doPortfolioCustomListPositions() must not be undefined");
  }

  const listTradeTickets = result.data.listTradeTickets;

  return listTradeTickets.items.map(convertApiToPortfolioPositionTradeTicket);
}
